import { aloApiFetch } from './alo-api-fetch';

const parseOtpResponse = async <T extends { message?: string; detail?: string }>(response: Response): Promise<T> => {
  const payload = (await response.json().catch(() => ({}))) as T;
  if (!response.ok) {
    throw new Error(payload.message || payload.detail || 'Unable to complete one-time code request.');
  }

  return payload;
};

export interface StartEmailOtpResponse {
  success: boolean;
  expiresAt?: number;
  expiresInSeconds?: number;
  resendAvailableAt?: number;
  resendAvailableInSeconds?: number;
  attemptsAllowed?: number;
  attemptsLeft?: number;
  codeLength?: number;
  message?: string;
}

export interface CompleteEmailOtpResponse {
  success: boolean;
  message?: string;
  redirectUrl?: string;
}

export const startEmailOtpSignIn = async (email: string): Promise<StartEmailOtpResponse> => {
  const response = await aloApiFetch('/v1/auth/otp/start', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });

  return parseOtpResponse<StartEmailOtpResponse>(response);
};

export const completeEmailOtpSignIn = async (
  email: string,
  otp: string,
  returnUrl?: string
): Promise<CompleteEmailOtpResponse> => {
  const response = await aloApiFetch('/v1/auth/otp/complete/web', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, otp, returnUrl }),
  });

  return parseOtpResponse<CompleteEmailOtpResponse>(response);
};
